import axios from "axios";

axios.defaults.withCredentials = false;
const AxiosWithoutToken = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api/v1/",
  crossDomain: false,
});

export default AxiosWithoutToken;
